export default [
  {
    date: 1445438181081,
    row: 6,
    col: 16,
    segments: [
      [5, 2, 2, 5],
      [2, 5, 7, 4],
      [7, 4, 5, 2],
      [10, 2, 15, 2],
      [15, 2, 14, 5],
      [14, 5, 12, 5],
      [12, 5, 10, 2]
    ]
  }
];
